export default __webpack_public_path__ + "static/ReMarkable-d6d61da7365e6958c25c08f7ad5a5184.png";